import { FC, useContext, useEffect, useRef } from "react";
import { SocketContext, TeamContext, UserContext } from "../../../context";
import { Loader } from "../../atoms";
import {  ReJoinTheGame, SlotMachineHeader, SlotMachineNotification } from "../../molecules";
import { SlotMachineRefObject } from "../../molecules/SlotMachine/SlotMachineChosenCardHolder";
import MidGameWaitingRoom from "./MidGameWaitingRoom";
import SlotMachineChosenCardHolderDemo from "./SlotMachineChosenCardHolderDemo";
import SlotMachineSpinnerDemo from "./SlotMachineSpinnerDemo";

const SlotMachineDemo : FC<{}> = () => {
    let slotMachineRef = useRef<SlotMachineRefObject>(null);
    const { teamNumber, game} = useContext(TeamContext);
    const { socket } = useContext(SocketContext);
    const { userData } = useContext(UserContext);
    const email = localStorage["userEmailInCaseHeLogsOut"];  
    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];


    return (
        <div>
            {teamNumber && 
            <div className="slot">
                {(!teamNumber || !userData) && !game ?
                 <div>
                    <Loader/>
                    <ReJoinTheGame />
                </div>
                :
                <div>
                    <MidGameWaitingRoom />
                    <SlotMachineHeader />
                    <SlotMachineNotification />
                    <SlotMachineSpinnerDemo slotMachineRef={slotMachineRef} />
                    <SlotMachineChosenCardHolderDemo ref={slotMachineRef} />
                </div>
}
            </div>
            
}
        </div>
    )

}

export default SlotMachineDemo;